/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const OrderClosingPage = lazyLoad(
  () => import('./index'),
  module => module.OrderClosingPage
);
